import ApiServer from "../ApiServer.ts";
import * as FwDatas from "../FwDatas.ts";
import * as modal from "../util/modal.ts";
import * as amplify from "../util/amplify.ts";
import * as i18n from "../i18n.ts";
import Icons from "../svg/Icons.ts";
import * as progressbar from "../util/progressbar.ts";
import { checkEventLimitOntry } from "./calendarclean.ts";

export async function importCalendarFile(file: File){
  var eventsCount = await countEventInIcalFile(file);
  var canAdd = await checkEventLimitOntry(undefined, eventsCount);
  if(!canAdd){
    modal.oops('eventclean.import_limit_exceeded');
    return;
  }
  var indexes = [];
  if(FwDatas.getPermission("icsconnect")==='takepremium' && eventsCount>30){
    var result = await modal.askAsPromise({
      title:"errors.oops",
      message:"calendars.importicslimit",
      lottie:"images/lottie/dizzy_face.json",
      button:[
        {title:"actions.gopremium",class:"premium",value:"false",action:"takepremium"},
        {title:"actions.later",class:"secondary",value:"true"}
      ]
    });
    if(result==="true"){
      indexes=[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30];
    }else{
      return;
    }
  }
  try{
    var resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file,indexes});
    if(resp.rightFlag==='KO_PREMIUM'){
      var doit30 = await modal.askAsPromise({
        title:"errors.oops",
        message:"calendars.importicslimit",
        lottie:"images/lottie/dizzy_face.json",
        button:[
          {title:"actions.gopremium",class:"premium",value:'false',action:"takepremium"},
          {title:"actions.later",class:"secondary",value:'true'}
        ]
      });
      if(doit30==='true'){
        resp = await ApiServer.evticalimport.setOptions({timeout:300000,progressbar:progressbar.standard})({file,indexes:[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30]});
      }else{
        return;
      }
    }
    modal.closeDomModal();
    var key = (resp.updated)?(resp.created?'calendars.importicsresult2':'calendars.importicsresult3'):'calendars.importicsresult1';
    modal.toast({svg:Icons.ic_done, text:i18n.get(key,resp)});
    amplify.publish('eventUpdated');
  }catch(err){
    modal.oops('calendars.calbyurl.errortext');
  }
}

function countEventInIcalFile(file: File): Promise<number>{
  return new Promise((resolve,reject)=>{
    var reader = new FileReader();
    reader.addEventListener('load', (event)=>{
      var str = event.target.result as string;
      resolve((str.match(/BEGIN:VEVENT/g) || []).length);
    });
    reader.addEventListener('error', reject);
    reader.readAsText(file);
  });
}
